import _toConsumableArray from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/img/result01@2x.png';
import _imports_1 from '@/assets/img/result02@2x.png';
import _imports_2 from '@/assets/img/result03@2x.png';
var _hoisted_1 = {
  class: "info-text"
};
var _hoisted_2 = {
  class: "rst_flex rst_top"
};
var _hoisted_3 = {
  class: "rst_span"
};
var _hoisted_4 = {
  class: "rst_flex"
};
var _hoisted_5 = {
  class: "rst_flex rst_spe"
};
var _hoisted_6 = {
  class: "rst_span"
};
var _hoisted_7 = {
  class: "rst_flex"
};
var _hoisted_8 = {
  class: "rst_span"
};
var _hoisted_9 = {
  class: "list-tab-box"
};
var _hoisted_10 = {
  class: "footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_CommonTable = _resolveComponent("CommonTable");
  var _component_el_tab_pane = _resolveComponent("el-tab-pane");
  var _component_el_tabs = _resolveComponent("el-tabs");
  var _component_el_button = _resolveComponent("el-button");
  var _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: $data.resultDialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.resultDialog = $event;
    }),
    class: "custom-dialog rst-dialog",
    width: "800px",
    top: "5vh",
    "append-to-body": true,
    "close-on-click-modal": false,
    onClosed: $options.onDialogClosed
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", null, [_cache[10] || (_cache[10] = _createElementVNode("h3", null, "查看结果", -1)), _createElementVNode("p", _hoisted_1, _toDisplayString($data.detailInfo ? $data.detailInfo.fileOriginName : ''), 1), _cache[11] || (_cache[11] = _createElementVNode("span", {
        class: "seat-line"
      }, null, -1)), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        class: "rst_img"
      }, null, -1)), _cache[3] || (_cache[3] = _createElementVNode("label", {
        class: "rst_label"
      }, "报关类型：", -1)), _createElementVNode("span", _hoisted_3, _toDisplayString($options.getFileTypeStr($data.detailInfo ? $data.detailInfo.type : '')), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[4] || (_cache[4] = _createElementVNode("img", {
        src: _imports_1,
        class: "rst_img"
      }, null, -1)), _cache[5] || (_cache[5] = _createElementVNode("label", {
        class: "rst_label"
      }, "数据形式：", -1)), _createElementVNode("span", _hoisted_6, _toDisplayString(!$options.isDraft ? '数据库表格' : '报关单草单'), 1)]), _createElementVNode("div", _hoisted_7, [_cache[6] || (_cache[6] = _createElementVNode("img", {
        src: _imports_2,
        class: "rst_img"
      }, null, -1)), _cache[7] || (_cache[7] = _createElementVNode("label", {
        class: "rst_label"
      }, "上传结果：", -1)), _createElementVNode("span", _hoisted_8, [_createTextVNode("成功新增" + _toDisplayString($data.detailInfo ? $data.detailInfo.success : 0) + _toDisplayString($options.isDraft ? '个文件' : '条') + "，重复上传" + _toDisplayString($data.detailInfo ? $data.detailInfo.repeat : 0) + _toDisplayString($options.isDraft ? '个文件' : '条') + "，", 1), _createElementVNode("em", null, "异常" + _toDisplayString($data.detailInfo ? $data.detailInfo.abnormal : 0) + _toDisplayString($options.isDraft ? '个文件' : '条'), 1)])])])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_tabs, {
        modelValue: $data.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return $data.activeName = $event;
        }),
        class: "custom_tabs",
        onTabClick: $options.handleClick
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_tab_pane, {
            label: "异常数据",
            name: "first"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_CommonTable, {
                class: "list-tab",
                "table-data": $options.abnormals,
                columns: $options.columns,
                options: $data.options
              }, null, 8, ["table-data", "columns", "options"])];
            }),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "重复上传数据",
            name: "second"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_CommonTable, {
                class: "list-tab",
                "table-data": $options.repeats,
                columns: $options.columns,
                options: $data.options
              }, null, 8, ["table-data", "columns", "options"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue", "onTabClick"])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
        round: "",
        onClick: $options.onCancelClick
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[8] || (_cache[8] = [_createTextVNode("取消", -1)]));
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        round: "",
        type: "primary",
        onClick: $options.onExoportClick
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[9] || (_cache[9] = [_createTextVNode("导出", -1)]));
        }),
        _: 1
      }, 8, ["onClick"])])])];
    }),
    _: 1
  }, 8, ["modelValue", "onClosed"]);
}